import { Component, inject, Input } from '@angular/core';
import { CommonModule } from 'node_modules/@angular/common';
import { NgbActiveModal } from 'node_modules/@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { INJECT_TYPE } from '../../constants';
import { DialogItem } from '../../dialog-item';
import { DIALOG_CONTROLLER, DialogController } from '../dialog-controller';

@Component({
	selector: 'app-basic-dialog',
	imports: [CommonModule],
	providers: [{ provide: DIALOG_CONTROLLER, useExisting: BasicDialogComponent }],
	templateUrl: './basic-dialog.component.html',
	styleUrl: './basic-dialog.component.scss'
})
export class BasicDialogComponent implements DialogController {
	private activeModal = inject(NgbActiveModal);

	private dataStream$ = new Subject<any>();
  public data$ = this.dataStream$.asObservable();

	INJECT_TYPE = INJECT_TYPE;

	@Input() title: string;
	@Input() injectContent: DialogItem[];
	@Input() autoFocus: boolean;

	emitData(data: any) {
		this.dataStream$.next(data);
	}

	dismiss(reason?: any) {
		this.dataStream$.complete();
		this.activeModal.dismiss(reason);
	}

	close(result?: any) {
		this.dataStream$.complete();
		this.activeModal.close(result);
	}
}
